import { useMutation, useQueryClient } from "react-query";
import { gql } from "graphql-request";
import { IDiscountRule } from "@pbm/discount-rules/contracts";
import { usePbm2Url } from "@common/hooks/usePbm2Url";

export function useUpdateDiscountRule() {
  const queryClient = useQueryClient();
  const { request } = usePbm2Url();
  return useMutation(async (variables) => {
    const { Rules_updateDiscountRule } = await request(
      gql`
        mutation ($input: Rules_UpdateDiscountRuleInput!) {
          Rules_updateDiscountRule(input: $input) {
            id
            type
            monthlyLimit
            effectiveSince
            effectiveUntil
            accountedProducts {
              ean
              name
              package
            }
            discountedProducts {
              ean
              name
              package
            }
            ranges {
              saleDiscountPercentage
              boxesFrom
              boxesTo
              daysBetweenSalesInterval
              daysWithoutSalesTolerance
            }
          }
        }
      `,
      { input: variables }
    );
    queryClient.invalidateQueries(
      `discountRule:${Rules_updateDiscountRule?.id}`
    );
    return Rules_updateDiscountRule as IDiscountRule;
  });
}
